module.exports = __webpack_public_path__ + "img/thumbnail_PronghornAntelope_m_normal.dc438d98.png";